// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  cursor: pointer;
  width: 100%;
  margin: 0 auto;
}
.btn .cut-corner-box {
  width: 135px;
  height: 40px;
  display: block;
}
.btn .cut-corner-box text {
  font-size: 60px;
  text-anchor: middle;
  dominant-baseline: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/button/button.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,cAAA;AACF;AAAI;EACI,YAAA;EACA,YAAA;EACA,cAAA;AAER;AAAI;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;AAER","sourcesContent":[".btn {\n  cursor: pointer;\n  width: 100%;\n  margin: 0 auto;\n    .cut-corner-box {\n        width: 135px;\n        height: 40px;\n        display: block;\n    }\n    .cut-corner-box text {\n        font-size: 60px;\n        text-anchor: middle;\n        dominant-baseline: middle;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
